<template>
    <div 
        cols="4"
        class="d-flex justify-end"
    >
        <v-btn
            text
            @click.prevent="mapFilterDialog= true" 
            min-width="17"
            class="pr-7"
        >
            <v-icon
                class="icon icon-horizontal-slider"
                :left="$vuetify.breakpoint.mdAndUp"
            />
            <span
                v-if="$vuetify.breakpoint.mdAndUp"
                class="habiteo-body-2 text-none"
            >
                {{ $t('sidebar.section.filters')}}
            </span>
        </v-btn>
        <MapFiltersDialog
            v-if="mapFilterDialog"
            :data="data"
            :mapFilterDialog="mapFilterDialog"
            @close="closeMapFilterPopup()"
            @apply-filters="applyMapFilter()"
        />
        <v-btn
            text
            class="pa-0 ma-0"
            @click.prevent="showSearchRoute()" 
            min-width="17"
        >
            <v-icon
                class="icon icon-map-view"
                :left="$vuetify.breakpoint.mdAndUp"
            />
            <span
                v-if="$vuetify.breakpoint.mdAndUp"
                class="habiteo-body-2 text-none"
            >
                {{ $t('map.searchRoute') }}
            </span>
        </v-btn>
    </div >
</template>

<script>
    import MapFiltersDialog from '@/layout/alternative/map//components/MapFiltersDialog';
    export default {
        name: "MapHeader",
        components: {
            MapFiltersDialog
        },
        props: [
            "data"
        ],
        data() {
            return {
                mapFilterDialog: false
            };
        },
        methods: {
            showSearchRoute(){
                this.$emit('toggle-search-route');
            },
            closeMapFilterPopup(){
                this.mapFilterDialog = false;
            },
            applyMapFilter(){
                this.data.points.forEach(point => {
                    point.categories.forEach(item => {
                        if(item.active)
                            this.data.refreshHotspots(item, item.active);
                    });
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/layout/alternative/map/MapHeader.vue